/**
 * @file
 * Creates a modal to show scam warning info and also a singleton that initializes
 * and opens said modal.
 */

import React from "react";

import Modal from "shared/components/Modal";
import Str from "shared/components/Str";
import ScamWarning from "shared/util/ScamWarning";
import _str from "shared/util/_str";

class ScamWarningModal extends React.Component {
	close = () => {
		ScamWarning.close();
	};

	render() {
		return (
			<Modal show={true} title={_str("Avoid internet scams")} onCancel={this.close}>
				<div className="scam-warning-modal aligncenter">
					<Str>Scams are rare, but you should always follow these guidelines:</Str>
					<br />
					<ol>
						<li><Str>Keep your conversation on OkCupid.</Str></li>
						<li><Str>Don’t give money to people on the Internet.</Str></li>
						<li><Str>Don’t believe people who claim to be stranded abroad.</Str></li>
						<li><Str>If you suspect that someone is a scammer, report them!</Str></li>
					</ol>

					<div className="buttons">
						<button
							className="flatbutton blue"
							type="button"
							onClick={this.close}
						>
							<Str>Close</Str>
						</button>
					</div>
				</div>
			</Modal>
		);
	}
}

export default ScamWarningModal;



// WEBPACK FOOTER //
// ./src/shared/components/ModalScamWarning.jsx